/**
 * Colored chip representing AgentStatus.
 */
import {
  hexToRGB,
  RED_300,
  RED_550,
  SIENNA_300,
  SIENNA_600,
  TEAL_300,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
import {IconName} from '@wandb/weave/components/Icon';
import React from 'react';

import {Chip} from '../Chip';
import {AgentStatus as AgentStatusType} from '../utilTypes';

type AgentStatusProps = {
  value: AgentStatusType | string;
};

const ICONS: Record<AgentStatusType, IconName> = {
  POLLING: 'flash-bolt',
  RUNNING: 'flash-bolt',
  STOPPING: 'warning',
  KILLED: 'failed',
};

const COLORS_BACKGROUND: Record<AgentStatusType, string> = {
  POLLING: hexToRGB(TEAL_300, 0.48),
  RUNNING: hexToRGB(TEAL_300, 0.48),
  STOPPING: hexToRGB(SIENNA_300, 0.48),
  KILLED: hexToRGB(RED_300, 0.48),
};

const COLORS_TEXT: Record<AgentStatusType, string> = {
  POLLING: TEAL_600,
  RUNNING: TEAL_600,
  STOPPING: SIENNA_600,
  KILLED: RED_550,
};

export const AgentStatus = ({value}: AgentStatusProps) => {
  const state = value as AgentStatusType;
  const stateStr = state.toString().toLowerCase();
  const label = stateStr.charAt(0).toUpperCase() + stateStr.slice(1);

  const bgColor = COLORS_BACKGROUND[state];
  const color = COLORS_TEXT[state];
  const iconName = ICONS[state];
  return (
    <Chip
      color={color}
      backgroundColor={bgColor}
      icon={iconName}
      label={label}
    />
  );
};
